import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import ChecklistKeselamatanOperasiSvc from "@/services/ChecklistKeselamatanOperasi";

@Module({ store, dynamic: true, namespaced: true, name: "checklist-keselamatan-operasi" })
class ChecklistKeselamatanOperasiModule extends VuexModule {
  data: any = null;
  loading = false;

  @Mutation SET_DATA(val: any) {
    this.data = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await ChecklistKeselamatanOperasiSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_DATA(data || null);
    } catch {
      this.SET_DATA(null);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_DATA(null);
  }
}

export const storeChecklistKeselamatanOperasi = getModule(ChecklistKeselamatanOperasiModule);
